import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { QUALITY_CHECKLIST_API } from "../apiRoutes";

interface UseGetQualityChecklistByProjectProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getQualityChecklistByProject = async (projectId: string) => {
  return await axiosAuth.get(`${QUALITY_CHECKLIST_API}/project/${projectId}`);
};

const useGetQualityChecklistByProject = ({
  projectId,
  queryParams,
}: UseGetQualityChecklistByProjectProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["quality-checklist", projectId],
    queryFn: () => getQualityChecklistByProject(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetQualityChecklistByProject;
